import { Select } from 'antd';
import { DefaultOptionType, SelectProps } from 'antd/lib/select';
import React, { useMemo } from 'react';

import { INTERNAL_ADMIN_ROLE_TO_LABEL, InternalAdminRole } from 'constants/internal-admin-roles';

export function InternalAdminRoleSelect(props: SelectProps<InternalAdminRole>) {
  const internalAdminRoleOptions: DefaultOptionType[] = useMemo(
    () => Object.entries(INTERNAL_ADMIN_ROLE_TO_LABEL).map(([value, label]) => ({ label, value })),
    []
  );

  return (
    <Select<InternalAdminRole>
      options={internalAdminRoleOptions}
      {...props}
    />
  );
}